export type UserType = "AMD" | "HQ" | "LO";
export type UseYn = "Y" | "N";


export class User {
  userNo: number;
  userId: string;
  vendorSeq: number;
  vendorName: string;
  userType: UserType;
  latestAt: number;
  useYn: UseYn;
  hqCode: string;
  hqName: string;
  hqSeq:string;
  shopCode: string;
  vendorCode: string;

  constructor(
    userNo: number,
    userId: string,
    vendorSeq: number,
    vendorName: string,
    userType: UserType,
    latestAt: number,
    useYn: UseYn
  ) {
    this.userNo = userNo;
    this.userId = userId;
    this.vendorSeq = vendorSeq;
    this.vendorName = vendorName;
    this.userType = userType;
    this.latestAt = latestAt;
    this.useYn = useYn;
  }
}



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/user/user.mode.ts